import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Label = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font: var(--theme-typography-bodyM-regular);
`

export const s = { Container, Label }
